/* c8 ignore start */
import {createPinia} from 'pinia';

export const pinia = createPinia();
